import { CreationToolFrame } from 'creation/src/creation-tools/types'
import CreationToolCutOutMode from 'creation/src/creation-tools/types/cut-out-mode'
import { createContext, useContext } from 'react'

export type Point = {
    x: number
    y: number
}

export type Path = {
    size: number
    mode: CreationToolCutOutMode
    points?: Point[]
}

// Legacy structural reference: components/cut-out/context.ts:16-49
// (`CreationToolCutOutContextProps`).
export type CutOutContextValue = {
    mode: CreationToolCutOutMode
    editCanvas: CreationToolFrame[]
    modeInstructionPreview?: CreationToolCutOutMode
    undoStepCount: number
    setMode: (mode: CreationToolCutOutMode) => void
    setModeInstructionPreview: (mode?: CreationToolCutOutMode) => void
    setUndoStepCount: (count: number) => void
    resetCanvas: () => void
    checkIfIsTransparentEnoughToContinue: () => void

    // Initial canvas
    sourceImageUrl?: HTMLImageElement

    // Pen Path config
    paths: Path[]
    updatePaths: (path: Path[]) => void

    // Erase config
    eraseSize: number
    setEraseSize: (size: number) => void

    // Brush config
    isBrushEnabled: boolean
    setBrushEnabled: () => void
    brushSize: number
    setBrushSize: (size: number) => void

    // Magic wand
    handleMagicWand: () => void

    // Reset
    isResetEnable: boolean
    setIsResetEnable: (boolean: boolean) => void
}

export const CutOutContext = createContext({} as CutOutContextValue)

export const useCutOut = (): CutOutContextValue => useContext(CutOutContext)
